import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Office } from "src/messages";

export interface OfficesState {
  agencyOffices: Office[];
}

const officesSlice = createSlice({
    name: "offices",
    initialState: {agencyOffices: []} as OfficesState,
    reducers: {
      set: (state, action: PayloadAction<Office[]> ) => { state.agencyOffices = action.payload; }
    }
});

export const { set: setOfficesActionCreator } = officesSlice.actions;
export default officesSlice.reducer;



// WEBPACK FOOTER //
// ./src/store/slices/officesSlice.ts